module.exports = __webpack_public_path__ + "img/rentpro.aeadc62c.svg";